export default "__VITE_ASSET__CDqj8BUZ__"